import { useEffect, useState } from "react";
import { TableViewServices } from "../services/table-view";
import { ITableViews, ITableViewsResponse } from "../interfaces/table-view";

interface TableViewsProps {
  tableName: string;
  shouldFetch?: boolean;
}

export const useTableViews = ({ tableName, shouldFetch = true }: TableViewsProps) => {
  const [dataTableView, setDataTableView] = useState<ITableViews>();
  const [loading, setLoading] = useState(true);

  const fetchTableViews = async () => {
    try {
      setLoading(true);
      const response: ITableViewsResponse = await TableViewServices.getTableViews(tableName);
      const { success, data } = response;
      if (success) {
        data.currentView = data.currentView || data.defaultView;
        setDataTableView(data);
      }
    } catch (error) {
      console.error("Fetch customize view error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (shouldFetch) {
      fetchTableViews();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldFetch]);

  return {
    dataTableView,
    setDataTableView,
    loading,
    refetchTableViews: fetchTableViews,
  };
};
